import script from "./GamesCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./GamesCarousel.vue?vue&type=script&setup=true&lang=js"

import "./GamesCarousel.vue?vue&type=style&index=0&id=ae561c6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae561c6c"]])

export default __exports__